import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=60d8654b"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=60d8654b&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports